export const zh_TW = {
    "PREFIX": {
        "QUESTION": "問題",
        "QUESTION-PART": "問題",
        "PRE-RELEASE": "Pre-Release",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "{{totalMarks > 1 && '分' || '分'}}"
    }   
};